module.exports = __webpack_public_path__ + "img/MGH-Nakasu-16-2440x1172.c7075a92.jpg";